import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { MapaService } from '../../../../services/mapa.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { VehiculosService } from '../../../../services/vehiculos.service';
import { ReporteCombustibleHistorico } from '../../../../../../_entities/vehiculos/ReporteCombustibleHistorico';
import { IGNICIONES, ALERTAS } from '../../../../../../_entities/estados';
import { GraficaHistoricoCombustibleComponent } from '../grafica-historico-combustible/grafica-historico-combustible.component';
import { HistoricoPosicionesActivoComponent } from '../../activos/historico-posiciones-activo/historico-posiciones-activo.component';
import { MapaMarkerComponent } from '../../../mapa-marker/mapa-marker.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'kt-historico-combustible',
  templateUrl: './historico-combustible.component.html',
  styleUrls: ['./historico-combustible.component.scss']
})
export class HistoricoCombustibleComponent implements OnInit {

  @ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;
  public reportePos: ReporteCombustibleHistorico[];
  public reportePosd: ReporteCombustibleHistorico;

	public reporte: any = [];
	public dataGrafica = [];
	public datos = [[1, 1]];
	public type = "line"
	public energySources = [
		{ value: "velocidad", name: "Velocidad" }
	];
	public showFilterRow: boolean;
  public showHeaderFilter: boolean;
	public vehiculoInfo;
	public idCliente;
	public fechaInicial;
	public fechaFinal;
	public fechaInicio;
	public idVehiculo;
	public fechaFin;
	public loadingVisible: boolean = false;
	public loadingMessage: string;
	public showPDFButton: boolean = false;
	public HWUser;
	public isDisable: boolean = false;
	public showTable: boolean = false;

	public showForm: boolean = true;

	colorScheme = {
		domain: ['#166BA2']
	};


	public legend: boolean = true;
	public showLabels: boolean = true;
	public animations: boolean = true;
	public xAxis: boolean = true;
	public yAxis: boolean = true;
	public showYAxisLabel: boolean = true;
	public showXAxisLabel: boolean = true;
	public timeline: boolean = true;
	public showGrafica = false;
	public datosReporte = [];
	public isDisabled: boolean = true;

	constructor(@Inject(MAT_DIALOG_DATA) public data: any,
		private datepipe: DatePipe,
		private toastService: ToastrService,
		public dialogRef: MatDialogRef<HistoricoCombustibleComponent>,
		private mapaService: MapaService,
		private vehiculoService:VehiculosService,
		public dialog: MatDialog,
		) {this.showFilterRow = true;
			this.showHeaderFilter = true; }

	ngOnInit() {
			this.idCliente = this.data.idCliente;
			this.idVehiculo = this.data.id;
			this.vehiculoInfo = this.data;

	}


	reportePosicion(fechaInicio: Date, fechaFinal: Date) {
		if (this.validationGroup.instance.validate().isValid) {
			this.loadingVisible = true;
			this.loadingMessage = 'Cargando...'
			this.fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
			this.fechaFinal = this.datepipe.transform(fechaFinal, "yyyy-MM-dd HH:mm:ss");
			setTimeout(() => {
				this.loadingMessage = 'Esto puede tardar unos segundos...';
			}, 15000);
			this.vehiculoService.getReporteHistoricoCombustible(this.idVehiculo,this.fechaInicial,this.fechaFinal).subscribe((result: ReporteCombustibleHistorico[]) =>{
				this.reportePos = result;
				if (this.reportePos.length > 0) {
					this.crearReporte(result);
					this.reportePos.map(dato => {
						let ignicion = IGNICIONES.find(ignicion => ignicion.id === dato.ignicion);
						dato.ignicionNombre = ignicion.nombre;

						let estado = ALERTAS.find(alerta => alerta.id == dato.estado);
						dato.estadoNombre = estado.nombre;
						dato.icono = estado.icono;

						dato.fecha = this.datepipe.transform(dato.fecha, 'dd/MM/yyyy hh:mm:ss a');
					});
				}
				else {
					this.isDisabled = true;
					this.showTable = false;
					this.loadingVisible = false;
					this.toastService.info("No existen datos en ese rango de fechas")
				}
				if(this.datosReporte.length > 0) {
					this.isDisabled = false;
				}
				if (this.reportePos.length > 0) {
					this.loadingVisible = false;
					this.showTable = true;
				}
			})
		}
	
	}


	crearReporte(reporte: ReporteCombustibleHistorico[]) {
		this.datosReporte = [];
		reporte.forEach(p => {
			this.datosReporte.push({
				'Fecha': this.datepipe.transform(p.fecha, 'dd-MM-yyyy - HH:mm a'),
				'Combustible': (p.combustible + ' L'),
				'Ignición': this.obtenerIgnicion(p.ignicion),
				'Estado': this.obtenerEstado(p.estado),
				'Velocidad Km/h': (p.velocidad + ' km/h' ),
			});
			if (this.datosReporte.length > 0) {
				this.isDisabled = false;
			}
		});
	}

	obtenerIgnicion(ignicion) {
		let tipoIgnicion = '';
		switch (ignicion) {
			case 0:
				tipoIgnicion = 'Apagado';
				break;
			case 1:
				tipoIgnicion = 'Encendido';
				break;
			case null:
				tipoIgnicion = 'Sin datos';
		}
		return tipoIgnicion;
	}

	obtenerEstado(estado) {
		let tipoEstado = '';
		switch (estado) {
			case 0:
				tipoEstado = 'Detenido';
				break;
			case 1:
				tipoEstado = 'Movimiento';
				break;
			case 2: 
				tipoEstado = 'Alerta Primaria';
				break;
			case 3:
				tipoEstado = 'Alerta Secundaria';
				break;
			case 4:
				tipoEstado = 'Detenido Más de  30 min';
				break
			case 5:
				tipoEstado = 'Detenido Más de 60 min';
				break;
			case 6:
				tipoEstado = 'Detenido Más de 90 min';
				break;
			case 7:
				tipoEstado = 'Exceso de Velocidad';
				break;
			case 8:
				tipoEstado = 'Fuera de Geocerca';
				break;
			case 9:
				tipoEstado = 'Batería Baja';
				break;
			case 10:
				tipoEstado = 'Falta de Energía';
				break;
			case 11:
				tipoEstado = 'Alerta de Movimiento';
				break;
			case null:
				tipoEstado = 'Sin Datos';
				break;
		}
		return tipoEstado;
	}	

	imprimirPdf() {
		this.loadingVisible = true;
		var grafica = document.getElementById('grafica')
		const PLACA = this.validarInfo(this.vehiculoInfo.placas);
		const ECONOMICO = this.validarInfo(this.vehiculoInfo.economico);
		const SERIE = this.validarInfo(this.vehiculoInfo.numeroSerie)
		const MARCA = this.validarInfo(this.vehiculoInfo.marca);
		const MODELO = this.validarInfo(this.vehiculoInfo.modelo);
		const ANIO = this.validarInfo(this.vehiculoInfo.anio);
		const COLOR = this.validarInfo(this.vehiculoInfo.color);
		const DESCRIPCION = this.validarInfo(this.vehiculoInfo.descripcion);
		let fechaHora = this.vehiculoInfo.fechaHoraUltimaPosicion;

		const FECHA_INICIAL = this.datepipe.transform(this.fechaInicial, 'dd/MM/yyyy h:MM a');
		const FECHA_FINAL = this.datepipe.transform(this.fechaFinal, 'dd/MM/yyyy h:MM a');

		fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');
		let direccion;

		this.mapaService.getDireccion([this.vehiculoInfo.lat, this.vehiculoInfo.lng]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";
			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);

		setTimeout(async () => {
			await html2canvas(grafica).then(
				(canvas) => {
					const graficaImagen = canvas.toDataURL('image/png');

					var pdf = new jsPDF('p', 'pt', 'a4');

					const logoGTM = './assets/media/logos/logo-gtm.png'
					const logoGTMX = 20;
					const logoGTMY = 15;
					const logoGTMWidth = 180;
					const logoGTMHeight = 80;
					pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

					const logoGTMWater = './assets/media/logos/marca-de-agua.png'
					const logoGTMWaterX = 15;
					const logoGTMWaterY = 130;
					const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
					const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
					const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
					pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

					pdf.setFontSize(18);
					pdf.setFont('', 'bold')
					pdf.text('Historial de Velocidades', 215, 120);
					pdf.text('Inicio: ' + FECHA_INICIAL + ' - Fin: ' + FECHA_FINAL, 90, 145)

					const PROPERTIES = (pdf as any).getImageProperties(graficaImagen);
					const WIDTH = pdf.internal.pageSize.getWidth() - 2 * 15;
					const HEIGHT = (PROPERTIES.height * WIDTH) / PROPERTIES.width;
					pdf.addImage(graficaImagen, 'PNG', 15, 170, WIDTH, 250);

					pdf.setFontSize(14);
					pdf.setFont('', 'bold')
					pdf.text('Datos del Dispositivo', 90, 470,);

					pdf.setFont('', 'normal')
					pdf.text('Vehículo:', 90, 485);
					pdf.text(MARCA + ', ' + MODELO, 340, 485);

					pdf.text('Placa:', 90, 500);
					pdf.text(PLACA, 340, 500);

					pdf.text('Económico:', 90, 515);
					pdf.text(ECONOMICO, 340, 515);

					pdf.text('Número de Serie:', 90, 530);
					pdf.text(SERIE, 340, 530);

					pdf.text('Año:', 90, 545);
					pdf.text(ANIO + '', 340, 545);

					pdf.text('Color:', 90, 560);
					pdf.text(COLOR, 340, 560);

					pdf.text('Descripción:', 90, 575);
					pdf.text(DESCRIPCION, 340, 575);

					pdf.text('Dirección:', 90, 590);
					pdf.text(direccion + '', 340, 590);

					pdf.setFontSize(12);
					pdf.setFont('', 'bold')
					pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
					pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
					pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, soporte.star@growtec.com.mx', 65, 825);

					const nombreArchivo = 'Historial_Velocidades';
					pdf.save(nombreArchivo + '.pdf');
					this.loadingVisible = false;

				}
			)
		}, 1)
	}

	validarInfo(valor) {
		let value = 'Sin Datos';

		if (valor) {
			value = valor
		}

		return value;
	}

	public tickFormatting(date: any) {
		const options = {
			hour: 'numeric',
			minute: 'numeric',
		};
		if (date.constructor.name === 'Date') {
			return date.toLocaleString('es-MX', options);
		}
		return date.toLocaleString('es-MX', options);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	
	mostrarGrafica() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = {datos:this.reportePos,info:this.vehiculoInfo, fechaInicio:this.fechaInicial,fechaFinal:this.fechaFinal};
		this.dialog.open(GraficaHistoricoCombustibleComponent,dialogConfig);
	
		}

	/**Obtener Reporte Velocidad */
	etiquetaModificada(arg) {

		return {
            text: arg.valueText + 'L'
        };
	}

	ubicar(data) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "50%";
		dialogConfig.height = "60%"
		dialogConfig.data = data;
		dialogConfig.panelClass = 'custom-modalbox';
		this.dialog.open(MapaMarkerComponent, dialogConfig);
	}

}
